import BookIcon from "@material-ui/icons/Book"

export class Apps {
    static book = "Módulo Biblioteca"
    static promocodes = "Módulo Promocode"
    static discounts = "Módulo Descontos"
    static communication = "Módulo Push"
    static integrations = "Módulo Integrações"
    static subscriptions = "Módulo Assinatura"
}